<template>
  <div
  >
    <document-container
      v-for="productType in productsByType"
      :key="productType.type"
      :footer="productType.template.footer()"
      :header="productType.template.header()"
      :logo="logo"
      :tables="productType.tables"
      documentType="multi-report"
      orientation="landscape"
    >

      <div
        slot="raw-header"
      >
        <img :src="logo" alt="" class="logo">

        <div class="header">
          <span class="supertitle">Advisory Mandat</span>
          <pagetitle
            :data="{title: productType.template.config.title.title.toUpperCase()}"
          ></pagetitle>
        </div>

      </div>

      <div
        v-for="table in productType.tables.tables"
        slot="raw-body"
        class="page-block"
      >

        <multi-report-table
          :id="table.id"
          :key="table.id"
          :table="table"
        ></multi-report-table>
      </div>
      <div
        slot="raw-footer"
        class="page-block"
      >
        <div>
          Quelle: BNP Paribas Wealth Management, Stand: {{ time }}. Indikationen sind freibleibend und unterliegen
          Schwankungen
        </div>
        <hr>
      </div>
    </document-container>
  </div>
</template>

<script>
import ProductService from '../../service/ProductService'
import ConfigService from '../../service/ConfigService'
import TemplateService from '../../service/TemplateManager'
import DocumentContainer from '../document/DocumentContainer'
import BlockMixin from '../block/BlockMixin'
import {Table} from '../../model/table/Table'
import {TableCollection} from '../../model/table/TableCollection'
import TokenService from "../../service/TokenService"
import MultiReportTable from "../table/TableMultiReport"

export default {
  components: {
    MultiReportTable,
    DocumentContainer,
  },

  name: 'MultiReport',

  data() {
    return {
      products: [],
      template: null,
      productsByType: []
    }
  },

  mixins: [BlockMixin],

  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: '/config/' + this.environment + '/style/multi_report.css'
        }
      ]
    }
  },

  props: {
    environment: {
      type: String
    },
    dqs: {
      type: String
    },
    appInstance: {
      type: String,
      required: false,
    }
  },

  methods: {
    sliceTable(table) {
      console.log(table)
      let sliceIndex = table.columns.findIndex(el => el.splitIndicator === 'SPLIT_AFTER')

      let maxRows = 24
      let multiRowCount = table.columns.reduce((sum, el) => {
        if (el.decoratorOptions && el.decoratorOptions.lines) {
          let length = el.decoratorOptions.lines.length
          return sum < length ? length : sum
        } else {
          return sum
        }
      }, 1)

      let tableRows = multiRowCount * table.products.length * 2
      let tables = []

      let maxProducts = maxRows / (multiRowCount * 2)
      let pages = Math.ceil(table.products.length / maxProducts)

      for (let x = 0; x < pages; x++) {
        tables.push(
          new Table(
            `${x}-1`,
            sliceIndex !== -1 ? table.columns.slice(0, sliceIndex + 1) : table.columns,
            table.products.slice(x * maxProducts, (x + 1) * maxProducts),
            MultiReportTable,
            null,
            table.pathToMultiRowCount,
          ),
        )
        if (sliceIndex !== -1) {
          tables.push(
            new Table(
              `${x}-2`,
              table.columns.slice(sliceIndex + 1),
              table.products.slice(x * maxProducts, (x + 1) * maxProducts),
              MultiReportTable,
              null,
              table.pathToMultiRowCount,
            )
          )
        }
      }


      return new TableCollection(
        ...tables
      )

    },
    getProducts(token) {
      ProductService.getMultiProductReport(
        this.environment,
        this.appInstance,
        token,
        this.dqs.split('+')
      ).then(res => {
        this.products = [
          ...res.data.data,
        ]


        for (let productType of this.products) {
          for (let subType of productType.onepagers) {
            ConfigService.getDocumentConfig(
              this.environment,
              'multi_report',
              'default',
              subType.type
            ).then(result => {
              this.productsByType.push({
                tables: this.sliceTable(subType),
                product: subType,
                template: new TemplateService(result.data)
              })
            })

          }
        }

      })
    }
  },

  computed: {
    logo() {
      return '/config/' + this.environment + '/images/logo.png'
    },
    time() {
      return this.moment().format('DD. MMMM YYYY')

    }
  },

  created() {
    if (this.$route.query.token) {
      this.getProducts(this.$route.query.token)
    } else {
      TokenService.getToken().then(result => {
        let token = result.data.token
        this.getProducts(token)
      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// MultiReport.vue?131a35ed